import harrington1 from "./harrington (1).png";
import harrington2 from "./harrington (2).png";
import harrington3 from "./harrington (3).png";
import harrington4 from "./harrington (4).png";
import harrington5 from "./harrington (5).png";
import harrington6 from "./harrington (6).png";
import harrington7 from "./harrington (7).png";

const harringtonimages = [
  harrington1,
  harrington2,
  harrington3,
  harrington4,
  harrington5,
  harrington6,
  harrington7,
];

export default harringtonimages;
